import { RefObject } from 'react';

import { hasTextOverflow } from 'utils/dom/domUtils';

export const renderTooltip = (refContainer: RefObject<Element>, contentText: string): string =>
  refContainer.current && hasTextOverflow(refContainer.current) ? contentText : '';
